import React from 'react';
import AttributeRow from '../../attributeRow';
import EmptyRequestDisplay from '../AssetHubNoData';
import type { AssetAttributesInfo } from 'actions/asset';
import type { AssetHubModalDetails } from '../assetHubModalTypes';

type AssetHubInfoProps = {
  modalDetails: AssetHubModalDetails | undefined;
  spanInfoError: boolean;
};

function isAttributesList(
  value: AssetHubModalDetails | undefined,
): value is ReadonlyArray<AssetAttributesInfo> {
  if (!Array.isArray(value) || value.length === 0) {
    return Array.isArray(value);
  }
  const first: unknown = value[0];
  return (
    typeof first === 'object' &&
    first !== null &&
    'name' in first &&
    'value' in first &&
    typeof (first as { name?: unknown }).name === 'string' &&
    typeof (first as { value?: unknown }).value === 'string'
  );
}

function formatDetailValue(value: unknown): string {
  if (value === null || value === undefined) return '';
  if (
    typeof value === 'string' ||
    typeof value === 'number' ||
    typeof value === 'boolean'
  ) {
    return String(value);
  }
  return String(value);
}

const AssetHubInfo: React.FC<AssetHubInfoProps> = ({
  modalDetails,
  spanInfoError,
}) => {
  return (
    <div>
      {spanInfoError ? (
        <div className="xa-asset_hub--info_container empty_request--container">
          <EmptyRequestDisplay />
        </div>
      ) : (
        <div className="xa-attributes-list xa-asset_hub--info_container">
          {modalDetails !== undefined && modalDetails != null ? (
            <div className="xa-attributes-list-head">
              <div className="xa-attributes-list-label">Name</div>
              <div className="xa-attributes-list-value-group">
                <div className="xa-attributes-list-value">Value</div>
              </div>
            </div>
          ) : (
            <div className="xa-asset_hub--info_container empty_request--container" />
          )}

          {modalDetails !== undefined &&
          modalDetails != null &&
          isAttributesList(modalDetails) ? (
            modalDetails.map((att) => (
              <AttributeRow name={att.name} value={att.value} key={att.name} />
            ))
          ) : modalDetails !== undefined && modalDetails != null ? (
            Object.keys(modalDetails as Readonly<Record<string, unknown>>)
              .filter(
                (k) =>
                  k !== 'geometry' &&
                  k !== 'attributes' &&
                  k !== 'elements' &&
                  k !== 'segmentable' &&
                  k !== 'parent' &&
                  k !== 'key' &&
                  k !== 'title' &&
                  k !== 'id',
              )
              .map((key) => {
                const record = modalDetails as Readonly<Record<string, unknown>>;
                return (
                  <AttributeRow
                    name={key}
                    value={formatDetailValue(record[key])}
                    key={key}
                  />
                );
              })
          ) : (
            <></>
          )}
        </div>
      )}
    </div>
  );
};
export default AssetHubInfo;
